import request from '../../untils/request';

// 区域
export function selectTreeList(data) {
	return request({
		url: '/sensorDistrict/selectTreeList',
		method: 'get',
		params: data,
	});
}

// 查询
export function detail(data) {
	return request({
		url: '/systemCustomConfig/detail2',
		method: 'get',
		params: data,
	});
}

// 保存
export function sava(data) {
	return request({
		url: '/systemCustomConfig',
		method: 'post',
		data: data,
	});
}

// 电账户欠费报警物业统一推送人信息列表查询
export function arrearsAlarmPropertyCommonPushManMeterSelectList() {
	return request({
		url: '/arrearsAlarmPropertyCommonPushManMeter/selectList',
		method: 'get',
	});
}

// 电账户欠费报警物业统一推送人信息保存
export function arrearsAlarmPropertyCommonPushManMeterSava(data) {
	return request({
		url: '/arrearsAlarmPropertyCommonPushManMeter',
		method: 'post',
		data: data,
	});
}

// 电账户欠费报警物业统一推送人信息删除
export function arrearsAlarmPropertyCommonPushManMeterRemove(param) {

	return request({
		url: '/arrearsAlarmPropertyCommonPushManMeter/' + param,
		method: 'delete',
	})
}
 // 电账户欠费报警物业统一推送人信息列表查询
export function arrearsAlarmPropertyCommonPushManWaterSelectList() {
	return request({
		url: '/arrearsAlarmPropertyCommonPushManWater/selectList',
		method: 'get',
	});
}

// 电账户欠费报警物业统一推送人信息保存
export function arrearsAlarmPropertyCommonPushManWaterSava(data) {
	return request({
		url: '/arrearsAlarmPropertyCommonPushManWater',
		method: 'post',
		data: data,
	});
}

// 电账户欠费报警物业统一推送人信息删除
export function arrearsAlarmPropertyCommonPushManWaterRemove(param) {

	return request({
		url: '/arrearsAlarmPropertyCommonPushManWater/' + param,
		method: 'delete',
	})
}

